import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const IndustryProductSpotlight = ({ eyebrow = "Featured Product", name, tagline, description, bullets, ctaLabel, ctaLink }) => {
   return (
      <section className="industry-spotlight pt-90 pb-90">
         <div className="tw-container tw-mx-auto">
            <div className="industry-spotlight__inner">
               <span className="industry-spotlight__eyebrow">{eyebrow}</span>
               <h2 className="industry-spotlight__name">{name}</h2>
               <h3 className="industry-spotlight__tagline">{tagline}</h3>
               <p className="industry-spotlight__desc">{description}</p>
               {bullets && bullets.length > 0 && (
                  <ul className="industry-spotlight__bullets">
                     {bullets.map((bullet, index) => (
                        <li key={index}>{bullet}</li>
                     ))}
                  </ul>
               )}
               <Link to={ctaLink} className="industry-spotlight__cta">
                  {ctaLabel}
                  <ArrowUpRight size={18} aria-hidden="true" />
               </Link>
            </div>
         </div>
      </section>
   );
};

export default IndustryProductSpotlight;
